import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios";
import VueAxios from "vue-axios";
import 'default-passive-events'
import moment from 'moment'
//导入接口地址
import apiCfg from "../config"

console.log("接口域名："+apiCfg.portalApi)

//将接口地址挂载到Vue上
Vue.prototype.Api = apiCfg.portalApi //客户端api根地址
Vue.prototype.mApi = apiCfg.managerApi;//管理端api根地址

Vue.use(VueAxios, axios);
Vue.use(ElementUI, {
  size: 'small'
});
Vue.config.productionTip = false;
//导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
      let title = sessionStorage.getItem('title'); 
      let ico = sessionStorage.getItem('ico');
      let company = sessionStorage.getItem('company');
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = ico
      document.getElementsByTagName('head')[0].appendChild(link);
      document.title = to.meta.title || "用户登录 -" + title;
       // 清除之前的meta标签
  const metas = document.querySelectorAll('meta[name="description"], meta[name="keywords"]');
  metas.forEach(meta => meta.parentNode.removeChild(meta));

  // 如果有新的meta信息，则添加
  if (to.meta.description) {
    const newMetaDescription = document.createElement('meta');
    newMetaDescription.name = 'description';
    newMetaDescription.content = to.meta.description;
    document.head.appendChild(newMeta === 'meta[name="keywords"]' ? meta : newMetaDescription);
  }else {
    // 如果没有 description，则添加默认的 description
    const defaultDescriptionMeta = document.createElement('meta');
    defaultDescriptionMeta.name = 'description';
    defaultDescriptionMeta.content='公司主要做FBA海运专线，整柜直送，头程FBA，空运FBA，与COSCO和美森有长期签约，价格好，服务有保障'; // 这里替换成你的默认描述内容
    document.head.appendChild(defaultDescriptionMeta);
  };
  if (to.meta.keywords) {
    const newMetaKeywords = document.createElement('meta');
    newMetaKeywords.name = 'keywords';
    newMetaKeywords.content = to.meta.keywords;
    document.head.appendChild(newMetaKeywords);
  }  else {
    // 如果没有 keywords，则添加默认的 keywords
    const defaultKeywordsMeta = document.createElement('meta');
    defaultKeywordsMeta.name = 'keywords';
    defaultKeywordsMeta.content = '海运专线，空运专线，FBA专线，物流系统，货代系统'; // 这里替换成你的默认关键词
    document.head.appendChild(defaultKeywordsMeta);
  }


      if (to.path === '/login' || to.path.indexOf('/search') == 0 || to.path.indexOf('/sql') == 0) {
        next();
      } else {
        let token = sessionStorage.getItem('token');
        if (!token) {
          next('/login');
        } else {
          /*路由发生改变修改页面的title */
          if(to.meta.title) {
            document.title = to.meta.title + " - 下单系统 - " + title
          }else{
            document.title = "下单系统 -" + title
          }
          next();
        }
      }
})
  

// 全局过滤器，将时间戳格式化为日期字符串
Vue.filter('dateformat', function (unixNum, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if (unixNum) {
    return moment.unix(unixNum).format(pattern)
  } else {
    return ''
  }
})

// 全局过滤器，将时间戳格式化为日期字符串
Vue.filter('dateformat1', function (unixNum, pattern = 'YYYY-MM-DD') {
  if (unixNum) {
    return moment.unix(unixNum).format(pattern)
  } else {
    return ''
  }
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");